import { ref } from 'vue';

import { _G } from '@/system_modules/utils/_common';

import moment from 'moment-timezone';


export const G = Object.assign(_G, {
    ajaxBaseUrl: {
        // "default": `http://localhost:8000/v1/frontend`,
        "default": `https://backend.pixonanimation.az/v1/frontend`,
    },

    ajaxHeaders: {
        'X-Reguest-With': () => {
            // return '__sdf$g@#%&*9wergw6^&*94GW4er__';
            return btoa(_G.exf9(moment.utc().valueOf()) + '.' + _G.exf9('__sdf$g@#%&*9wergw6^&*94GW4er__'));
        },
    },

    captcha_key: ref(''),

    // mediaURL: `http://127.0.0.1:8000/`,

    main_host: 'demo.pixonanimation.az',

    defaultSelectedMenu: "home",

    defaultPage: "pages/Home",

    projectName: "pixonanimation",
    projectSubtitle: "pixonanimation",
    projectInfo: `Pixon Animation`,

    footerPowered: '<a href="https://diarc.az" class="footer-info-link mx-1" target="_blank">Powered with <b class="text-danger">♥</b> by DiArc MMC</a>',
    footerDescription: 'pixonanimation.az',

    rowsPerPage: 10,
    rowsPerPageOptions: [5, 10, 15, 25, 50, 100],

    // uploadedFileSize: 52428800,
    uploadedFileSize: 10485760, // 10 Mb

    showFilterAfterLength: 15,

    toastLifeTime: 2000,

    ignored_routes: [
        "pdf_viewer_letter",
        "pdf_viewer",
    ],

    datetime_format: {
        'pg_datetime': 'YYYY-MM-DD HH:mm:ss',
        'datetime': 'DD.MM.YYYY HH:mm:ss',
        'date': 'DD.MM.YYYY',
        'year': 'YYYY',
        'month': 'MM.YYYY',
        'time': 'HH:mm:ss',
        'hourminute': 'HH:mm',
        'for_file': 'DD.MM.YYYY__HH.mm.ss',
        'for_print': 'DD.MMM.YYYY HH:mm',
        'datetime_as_pg': 'YYYY-MM-DDTHH:mm:ss.SSSZ',
        'news_date': 'DD MMMM YYYY',
        'news_datetime': 'DD MMMM YYYY HH:mm:ss',
    },

});
